import { computed, type Ref } from "vue";
import type { MultipackOption } from "~/templates/breadandboxers/composables/useMultipackPricing";

export const useProductPricing = (params: {
	selectedBreak: Ref<MultipackOption | undefined>;
	baseUnitPrice: Ref<number>;
	productOldUnitPrice: Ref<number | null>;
	cartQuantity: Ref<number>;
}) => {
	const pricing = computed(() => {
		const selected = params.selectedBreak.value;
		const currentUnitPrice = selected?.unitPrice ?? params.baseUnitPrice.value;
		let oldUnitPrice =
			selected?.oldUnitPrice ?? params.productOldUnitPrice.value;

		if (!oldUnitPrice && currentUnitPrice < params.baseUnitPrice.value) {
			oldUnitPrice = params.baseUnitPrice.value;
		}

		// Both rounded the same way, because the caller decides whether the
		// product is discounted by comparing them. One left as a raw product and
		// the other rounded made two equal prices differ by a fraction of a cent,
		// which showed as a struck-through price on a product at full price.
		const toCents = (value: number) => Number(value.toFixed(2));

		return {
			currentUnitPrice,
			oldUnitPrice,
			total: toCents(currentUnitPrice * params.cartQuantity.value),
			totalOld: oldUnitPrice
				? toCents(oldUnitPrice * params.cartQuantity.value)
				: null
		};
	});

	return {
		pricing
	};
};
